import { t } from "i18next";
import { Station } from "../slices/local/user";

export const getStationName = (station: Station): string => {
  if (!station) {
    return t('station.unknown_station');
  }

  let stationName = station.displayName
    .replace(/<(.|\n)*?>/g, ' ')
    .replace(/\s+/g, ' ');

  if (!stationName) {
    stationName = station.name;
  }

  return stationName;
}
